import { Component, OnInit } from '@angular/core';

declare const $: any;

@Component({
  selector: 'maintenance',
  styles: [`
    :host { display: block; }

    .main-page {
      background-color: #e5f0fc;
      min-height: 100vh;
    }

    .logo { padding-top: 20%; width: 45%; max-width: 260px; }

    .retour-title {
      padding-top: 12.5%;
      padding-bottom: 4%;
      font-family: "Gotham SSm A", "Gotham SSm B", Verdana, sans-serif;
      font-size: 40px;
      line-height: 0.95;
      text-align: left;
      color: #002c6c;
      display: flex;
    }

    .retour-details {
      padding-bottom: 4%;
      font-family: "Gotham SSm A", "Gotham SSm B", Verdana, sans-serif;
      font-size: 20px;
      line-height: 1.1;
      text-align: left;
      color: #002c6c;
      display: flex;
    }

    .elevated-white-rectangle {
      width: 88%;
      padding: 2%;
      margin-bottom: 15%;
      border-radius: 4px;
      box-shadow: 0 2px 3px 0 rgba(0, 44, 108, 0.2);
      border: solid 1px #e5f0fc;
      background-color: #fff;
    }

    .retour-contact {
      font-family: "Gotham SSm A", "Gotham SSm B", Verdana, sans-serif;
      font-size: 18px;
      line-height: 1.39;
      text-align: left;
      color: #002c6c;
      display: flex;
    }

    .tel-symbol, .mail-symbol {
      max-width: 300px;
      margin: 10px 5px;
      font-family: "Gotham SSm A", "Gotham SSm B", Verdana, sans-serif;
      font-size: 15px;
      line-height: 1.4;
      text-align: left;
      color: #002c6c;
      display: flex;
    }

    img.telephone-fill, img.envelope-fill {
      width: 12px;
      height: 12px;
      margin: 0 0 -1px 0;
      object-fit: contain;
    }

    .link-color { color: #00799e; padding-left: 5px; font-size: 15px; }

    * { box-sizing: border-box; }
    .row::after { content: ""; clear: both; display: table; }
    [class*="col-"] { float: left; padding: 15px; width: 100%; }

    @media only screen and (min-width: 600px) {
      .col-s-1 {width: 8.33%;}
      .col-s-2 {width: 16.66%;}
      .col-s-3 {width: 25%;}
      .col-s-4 {width: 33.33%;}
      .col-s-5 {width: 41.66%;}
      .col-s-6 {width: 50%;}
      .col-s-7 {width: 58.33%;}
      .col-s-8 {width: 66.66%;}
      .col-s-9 {width: 75%;}
      .col-s-10 {width: 83.33%;}
      .col-s-11 {width: 91.66%;}
      .col-s-12 {width: 100%;}
    }
    @media only screen and (min-width: 768px) {
      .col-1 {width: 8.33%;}
      .col-2 {width: 16.66%;}
      .col-3 {width: 25%;}
      .col-4 {width: 33.33%;}
      .col-5 {width: 41.66%;}
      .col-6 {width: 50%;}
      .col-7 {width: 58.33%;}
      .col-8 {width: 66.66%;}
      .col-9 {width: 75%;}
      .col-10 {width: 83.33%;}
      .col-11 {width: 91.66%;}
      .col-12 {width: 100%;}
    }
  `],
  template: `
    <div class="main-page">
      <div class="container">
        <div class="row">
          <div class="col-3 col-s-12">
            <img src="assets/icons/gs1-fav-icon.svg" class="logo" alt="GS1 France">
          </div>
        </div>

        <div class="row mb-3"></div>

        <div class="row">
          <div class="col-8 col-s-8 menu">
            <span class="retour-title">Nous sommes bientôt de retour !</span>
            <div class="retour-details">
              <span id="maintenanceContent">
              </span>
            </div>

            <div class="elevated-white-rectangle">
              <span class="retour-contact">
                Notre service client reste à votre disposition pour toute demande :
              </span>

              <span class="tel-symbol">
                <span>
                  <img src="assets/img/telephone-fill.svg" class="telephone-fill" alt="">
                  &nbsp;Par téléphone :
                </span>
                <span style="padding-left: 5px; font-size: 15px;">01 40 22 18 00</span>
              </span>

              <span class="mail-symbol componentbody-littlebody-little-anchor-link">
                <span>
                  <img src="assets/img/envelope-fill.svg" class="envelope-fill" alt="">
                  &nbsp;Par mail :
                </span>
                <a href="mailto:serviceclient@gs1fr.org" class="link-color">
                  <span>serviceclient@gs1fr.org</span>
                </a>
              </span>
            </div>
          </div>

          <div class="col-3 col-s-12">
            <img src="assets/img/groupe-8.svg"
                 style="max-width:450px;max-height:450px;object-fit:contain"
                 alt="">
          </div>
        </div>
      </div>
    </div>
  `
})
export class Maintenance implements OnInit {
  public ngOnInit(): void {
    let message = "Le site n'est pas disponible actuellement, merci de réessayer dans quelques minutes.";
    $(document).ready(function() {
      const url = '/alerts.json';
      const maintenanceContent = $('#maintenanceContent');
      $.ajax({ url, dataType: 'json' })
        .done(function(result: any) {
          const maintenanceObj = result.maintenance || {};
          if (maintenanceObj.content) {
            message = maintenanceObj.content;
          }
        })
        .always(function() {
          maintenanceContent.html(message);
        });
    });
  }
}
